import React, { Component } from 'react'
import { matchPath, withRouter } from 'react-router-dom';
import * as Constants from '../../common/Global/constants';
import { isEmptyVariable,getThemeSettingsVariables, hasFeatureAccess } from '../../common/Global/commonFunctions';
import { TopTabsLayout } from '../../common/Global/globalStyles.style';

let isClient ='';
let isDepartment ='';
let isAssignmentType ='';
let isTemplate ='';
let themeColor = ``;
let themeSettings = getThemeSettingsVariables();
class SettingTopMenu extends Component {
    constructor(props) {
        super(props);
        this.state = {
            showLoader: false,
        }
        themeSettings = getThemeSettingsVariables();
        isClient = this.checkActivePath("/clientSettings");
        isDepartment = this.checkActivePath("/departmentsettings");
        isAssignmentType = this.checkActivePath("/assignmenttypesettings");
        isTemplate = this.checkActivePath("/templatesettings");
    }
    checkActivePath = (path) =>{
        themeSettings = getThemeSettingsVariables();
        themeColor = `rgba(${themeSettings.themeColor.r},${themeSettings.themeColor.g},${themeSettings.themeColor.b},${themeSettings.themeColor.a})`;
       return matchPath(this.props.history.location.pathname, { path });
    }
  render() {

    let width = 60;
    // if (!isEmptyVariable(this.props.masterMenus)) {
    //     width = 12.5 * Object.keys(this.props.masterMenus).length
    // }
    return (
        <TopTabsLayout themeSettings={this.props.themeSettings}>
        {this.state.showLoader && (
            <div class="loader"></div>
        )}
        <div className="question-tabs" style={{ marginRight: 0 }}>
            
                <ul style={{ width: width + "%" }}>
                  {(!isEmptyVariable(this.props.menus['Client Settings']) && this.props.menus['Client Settings'] !== "NONE")&& 
                       <li
                            className={
                                matchPath(this.props.history.location.pathname, { path: "/clientSettings" })
                                    ? "questiontab-active"
                                    : ""
                            }
                            >
                            <a href={Constants.URL_CLIENT_SETTINGS}
                                style={{color: !isClient ? themeColor : '', fontWeight: !isClient ? "bold" : "100px"}}>Client</a>
                        </li>
                    }
                       
                    {(!isEmptyVariable(this.props.menus['Department Settings']) && this.props.menus['Department Settings'] !== "NONE") &&
                        <li
                            className={
                                matchPath(this.props.history.location.pathname, { path:"/departmentsettings"})
                                    ? "questiontab-active"
                                    : ""
                            }
                        >
                            <a href={Constants.URL_DEPARTMENT_SETTINGS}
                                style={{color: !isDepartment ? themeColor : '', fontWeight: !isDepartment ? "bold" : "100px"}}>Department</a>
                        </li>
                    }
                    {(!isEmptyVariable(this.props.menus['Assignment Settings']) && this.props.menus['Assignment Settings'] !== "NONE") &&
                        <li
                            className={
                                matchPath(this.props.history.location.pathname, { path:"/assignmenttypesettings"})
                                    ? "questiontab-active"
                                    : ""
                            }
                        >
                            <a href={Constants.URL_ASSIGNMENT_TYPE_SETTINGS}
                                style={{color: !isAssignmentType ? themeColor : '', fontWeight: !isAssignmentType ? "bold" : "100px"}}>Assignment Type</a>
                        </li>
                    }
                    {(!isEmptyVariable(this.props.menus['Template Settings']) && this.props.menus['Template Settings'] !== "NONE") &&
                        <li className={
                            matchPath(this.props.history.location.pathname, { path:"/templatesettings"})
                                ? "questiontab-active"
                                : ""
                        }>
                            <a href={Constants.URL_TEMPLATE_SETTINGS}
                                style={{color: !isTemplate ? themeColor : '', fontWeight: !isTemplate ? "bold" : "100px"}}>Template</a>
                        </li>
                    }
                </ul>
            
        </div>

    </TopTabsLayout>
    )
  }
}

export default withRouter(SettingTopMenu);
